import React from 'react'
import GetInTouch from '../../Components/Offers/GetInTouch'
import Map from '../../Components/Contact/Map'
import BookYourService from '../../Components/Common/BookYourService'
import SimpleBanner from "../Common/SimpleBanner";
import AboutUs_banner from '../../Assets/home/BannerImage.png'
const Contact = () => {
  return (
    <div className='overflow-hidden'>
       <SimpleBanner
        image={AboutUs_banner}
        name="Contact"
        path="Home >> Contact"
      />
      <GetInTouch/>
      <Map/>
      <BookYourService/>
    </div>
  )
}

export default Contact
